<div class="w-100 text-center pt-5"> 
    <h2>Hello, You are not authorized to access this page, please contact insuropexchange@insurope.com to continue.</h2>
   <div class="text-center w-100 d-flex justify-content-center"> <button (click)="userService.logout()" class="btn btn-light logout mt-3 ">
        <!-- <fa-icon [icon]="faUser"></fa-icon> -->
        <span>Log out</span>
    </button></div>
</div>